<mf-page title="Detalles de la acreditación">
  @if(accreditation) {
  <mf-column-display label="Id">
    {{ accreditation.id }}
  </mf-column-display>

  <mf-track-grid [id]="accreditation.id" />
  }
</mf-page>
